import { AbstractControl, Validators } from '@angular/forms';

// Value must pass Validators.required and also have values if it is an array
export const requiredAndNotEmpty = (control: AbstractControl) => {
  if (Array.isArray(control.value) && !control.value.length) {
    return { required: true };
  }
  return Validators.required(control);
};
